// Namespace tokens to avoid collisions with other apps (dashboard/goplan) in same browser.
const APP_STORAGE_KEY = 'golibrary2';

export const ACCESS_TOKEN_KEY = `access_token:${APP_STORAGE_KEY}`;
export const REFRESH_TOKEN_KEY = `refresh_token:${APP_STORAGE_KEY}`;
export const ID_TOKEN_KEY = `id_token:${APP_STORAGE_KEY}`;

export const SUB_KEY = `sub:${APP_STORAGE_KEY}`;

export const KEYCLOAK_CLIENT_ID = window._env_.VITE_KEYCLOAK_CLIENT_ID || import.meta.env.VITE_KEYCLOAK_CLIENT_ID || '';

export const KEYCLOAK_REALM_NAME =
  window._env_.VITE_KEYCLOAK_REALM_NAME || import.meta.env.VITE_KEYCLOAK_REALM_NAME || '';
